import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CommonService } from '@tech-services/common.service';
import { CompletedataService } from '@tech-services/completedata.service';
import { ProfileportfolioService } from '@tech-services/profileportfolio.service';
import {
  ClientDataApiRest,
  OperativeBankInfoResponseInterface,
  OperativeService,
  CompleteDataPortfolioDataInterface,
  FundingDataInterface
} from '@techrules/portallib';
import { Subject, throwError } from 'rxjs';
import { catchError, map, takeUntil } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { CurrencyPipe } from '@techrules/pipelib';

@Component({
  selector: 'tech-modal-cashin',
  templateUrl: './modal-cashin.component.html',
  styleUrls: ['./modal-cashin.component.scss'],
})
export class ModalCashinComponent implements OnInit {
  private unsubscribe$ = new Subject();
  public funding: FundingDataInterface;
  public portfolioGoCashIn: CompleteDataPortfolioDataInterface;
  public bankData: OperativeBankInfoResponseInterface;
  public clientData: ClientDataApiRest;
  public isLoaded: boolean = false;
  public textParagraph1: string = '';
  public textParagraph2: string = '';

  constructor(
    public dialogRef: MatDialogRef<ModalCashinComponent>,
    private profileportfolioService: ProfileportfolioService,
    private completedataService: CompletedataService,
    private operativeService: OperativeService,
    private commonService: CommonService,
    private translate: TranslateService,
    private currencySymbol: CurrencyPipe
  ) {}

  ngOnInit(): void {
    this.commonService.clientDataInitial$
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((data) => {
        this.clientData = data;
      });
    this.profileportfolioService.portfolioGoCashIn$
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((data: any) => {
        this.portfolioGoCashIn = data;
        localStorage.setItem('portfolioCode', data.PortfolioCode);
      });

    this.getFunding()
      .pipe()
      .subscribe((result) => {
        this.funding = result;
        this.operativeService
          .getBankInfo(
            this.portfolioGoCashIn.ServiceModelCode !== ''
              ? this.portfolioGoCashIn.ServiceModelCode
              : 'AP'
          )
          .subscribe((data) => {
            this.bankData = data[0];
            this.translate.get('k003068').subscribe((text) => {
              //Token: <p>Nos alegra mucho comunicarte que toda la información enviada ha sido validada satisfactoriamente y estás solo a un paso de poder iniciar tu inversión.</p><p>Para que podamos efectuar la adquisición de tu cartera debes realizar la transferencia de <b>{0}</b> desde <b>{1}</b> (cantidad y banco emisor que indicaste durante el registro) utilizando los detalles de destino mostrados a continuación:</p>
              text = text
                .replace(
                  '{0}',
                  this.currencySymbol.transform(
                    this.funding.CashAmount,
                    this.funding.CashCurrency,
                    '1.0-0'
                  )
                )
                .replace('{1}', this.funding.BankName);
              this.textParagraph1 = text;
            });
            this.bankData.message = this.bankData.message
              .replace('{code}', this.portfolioGoCashIn.PortfolioCodeView)
              .replace('{name}', this.clientData.Name)
              .replace('{surname}', this.clientData.Surname);
            this.translate.get('k003067').subscribe((text) => {
              //Token: Es importante que no olvides introducir tu identificador individual <b>{0}</b> como concepto/mensaje de la transferencia.
              text = text.replace('{0}', this.bankData.message);
              this.textParagraph2 = text;
            });
            this.isLoaded = true;
            this.commonService.loading$.emit(false);
          });
      });
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next(null);
    this.unsubscribe$.complete();
  }

  goOut(): void {
    this.dialogRef.close();
  }

  public getFunding() {
    return this.completedataService.getFunding().pipe(
      map((res) => {
        return res;
      }),
      catchError((err) => {
        this.commonService.errorManager('get_Funding', err);
        return throwError(err);
      })
    );
  }
}
